import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import querystring from 'query-string';
import labelRequest from '../labelRequest';

export default function getAlerts(wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, options } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of getAlerts()');
    invariant(brandId, 'brandId is a required param of getAlerts()');
    invariant(country, 'country is a required param of getAlerts()');
    invariant(uberToken, 'uberToken is a required param of getAlerts()');
    invariant(clientId, 'clientId is a required param of getAlerts()');

    const headers = { 'Content-Type': 'application/json' };

    // For TON we're only displaying unseen alerts rather than all alerts
    const filterByAvailability = brandId === 'ton' ? 'filterByAvailability=6' : 'filterByAvailability=5';
    const optionalQuery = options && Object.keys(options).length > 0 ? `&${querystring.stringify(options)}` : '';
    const fetchUrl = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/v2/@self/item?${filterByAvailability}&showNotificationStatus=true&sortBy=15${optionalQuery}`;

    return labelRequest(
        authenticatedRequest(new Request(fetchUrl, { headers: new Headers(headers), method: 'GET' }), uberToken, clientId, clientSecret),
        'getAlerts',
    );
}
